<script>
  import { trim } from "../../utils.js";
  import { showLoader } from "../../dialog.js";
  import { HStack, Spacer } from "../layout";
  import { createEventDispatcher } from "svelte";
  import { Text, Choice, TextEditor } from "../widget";
  import { categories } from "../../articles";

  export let show;
  export let submit;
  export let cancel;

  export let articleId = null;
  export let title = null;
  export let category = "A";
  export let ranking = 0;
  export let content = null;
  let current = null;

  let showError;
  let errorMessage;

  const dispatch = createEventDispatcher();

  const handle_submit = async () => {
    const close = showLoader();
    try {
      await submit(trim(title), category, ranking, content, articleId);
      reset();
    } catch (e) {
      showError = true;
      errorMessage = e;
    }
    close();
    dispatch("refresh");
  };

  const handle_cancel = () => {
    if (articleId == null) {
      reset();
    }
    cancel();
  };

  const reset = () => {
    title = null;
    content = null;
    category = "A";
    current = "";
    ranking = 0;
    showError = false;
    errorMessage = null;
  };

  const validate = (event) => {};
</script>

<form
  class:opened={show}
  on:submit|preventDefault={handle_submit}
  on:invalid={validate}
  on:changed={validate}
  on:input={validate}>
  {#if showError}
    <div class="error">Une erreur s'est produite: {errorMessage}</div>
  {/if}
  <Text
    id={"title"}
    reset
    required
    bind:value={title}
    icon="fas fa-pen"
    label="Titre"
    placeholder="Titre"
    bind:current />

  <Choice
    id={"category"}
    label="Catégorie"
    bind:value={category}
    bind:current
    icon="fas fa-archive"
    values={categories} />

  <Text
    id={"ranking"}
    type="number"
    required
    reset
    bind:value={ranking}
    icon="fas fa-sort-numeric-down"
    label="Ordre"
    placeholder="Ordre"
    bind:current />

  <TextEditor
    id={"content"}
    reset
    required
    bind:value={content}
    icon="fas fa-file"
    label="Contenu"
    placeholder="Saisissez ici votre article"
    bind:current />

  <HStack>
    <button class="cancel" type="button" on:click={handle_cancel}>
      <i class="fas fa-angle-double-up" />
      <span>Annuler</span>
    </button>
    <button class="primary" type="submit">
      <i class="fas fa-folder-plus" />
      {#if articleId}
        <span>Modifier</span>
      {:else}
        <span>Ajouter</span>
      {/if}
    </button>
    <Spacer />
  </HStack>
</form>

<style>
  form {
    margin: 5px;
    border-radius: 15px;
    transform: scaleY(0);
    transform-origin: 50% 0;
    transition: none;
    height: 0;
  }
  form.opened {
    border: 2px solid var(--secondary-light-color);
    padding: 1em;
    transform: scaleY(1);
    transition: transform 0.3s ease-out;
    height: auto;
  }

  button {
    margin-left: 1em;
  }
  div.error {
    color: var(--error-color);
    background-color: #fff;
    display: block;
    font-size: 12px;
    margin: auto;
    padding: 1em;
  }
</style>
